// src/posts.js

// Series metadata
export const series = {
    "mcp-guide": {
        slug: "mcp-guide",
        title: "Model Context Protocol Guide",
        description: "A comprehensive guide to building and integrating MCP servers",
        icon: "🔌",
        category: "guide"
    },
    "hls-tutorial": {
        slug: "hls-tutorial",
        title: "HLS & FPGA Development",
        description: "Learn High-Level Synthesis and FPGA optimization techniques",
        icon: "⚡",
        category: "guide"
    },
    "novelty-generalisation": {
        slug: "novelty-generalisation",
        title: "Novelty generation in Transformers",
        description: "Novelty generation demonstrated through addition",
        icon: "🧐",
        category: "guide"
    },
    "tx-frontend": {
        slug: "tx-frontend",
        title: "RF Tx Frontend using a PLL and DDS",
        description: "Creating an RF transmitter with Analog Device chips and controlled by an FPGA",
        icon: "📡",
        category: "guide"
    },
    // Add more series as needed
};

// Posts with series grouping
export const posts = [
    {
        slug: "tx-frontend-1",
        title: "Part 1: Overview of planned the Tx Frontend",
        date: "2026-01-10",
        excerpt: "PLLs, DDS, and how it all goes together",
        mdPath: "/posts/building-radio-1.md",
        category: "guide",
        series: "tx-frontend",
        seriesOrder: 1
    },
    {
        slug: "hls-forloop-tutorial1",
        title: "Part 1: Matrix Multiplication with HLS",
        date: "2025-10-05",
        excerpt: "Parallelising, processing and moving data with a for loop",
        mdPath: "/posts/hls-forloop-tutorial1.md",
        category: "guide",
        series: "hls-tutorial",
        seriesOrder: 1
    },
    {
        slug: "building-mcp-server1",
        title: "Part 1: A file browser MCP Server",
        date: "2025-11-01",
        excerpt: "A hello world type demonstration of an MCP server",
        mdPath: "/posts/building-mcp-server1.md",
        category: "guide",
        series: "mcp-guide",
        seriesOrder: 1
    },
    {
        slug: "building-mcp-server2",
        title: "Part 2: Integrating the MCP Server into the Host Apps",
        date: "2025-11-02",
        excerpt: "Integrating the file browser into a host application",
        mdPath: "/posts/building-mcp-server2.md",
        category: "guide",
        series: "mcp-guide",
        seriesOrder: 2
    },
    {
        slug: "email-calendar-mcp-server",
        title: "A daily meeting preparation aid",
        date: "2025-11-09",
        excerpt: "Providing a summary for the days meetings by extracting useful information from calendar and emails",
        mdPath: "/posts/email-calendar-mcp-server.md",
        category: "guide",
        series: "mcp-guide",
        seriesOrder: 3
    },
    {
        slug: "fastmcp-search-llm",
        title: "FastMCP: easily allowing LLMs to do web searches",
        date: "2025-11-15",
        excerpt: "Abstracting lower level MCP with FastMCP",
        mdPath: "/posts/fastmcp-search-llm.md",
        category: "guide",
        series: "mcp-guide",
        seriesOrder: 4
    },
    {
        slug: "baseline-model",
        title: "Part 1: Addition in an Autoregressive Transformer",
        date: "2025-11-15",
        excerpt: "Setting the baseline by showing what a simple transformer can/can't learn when given an addition dataset",
        mdPath: "/posts/part1-novelty-addition.md",
        category: "guide",
        series: "novelty-generalisation",
        seriesOrder: 1
    },
    {
        slug: "baseline-model-understanding",
        title: "Part 2: Understanding what the baseline model is doing",
        date: "2025-12-06",
        excerpt: "Applying interpretability and other techniques to study the performance of the baseline model",
        mdPath: "/posts/part2-novelty-addition-interpretability.md",
        category: "guide",
        series: "novelty-generalisation",
        seriesOrder: 2
    },
];

// Helper functions
export const byDateDesc = (a, b) => (a.date < b.date ? 1 : -1);
export const bySeriesOrder = (a, b) => (a.seriesOrder || 0) - (b.seriesOrder || 0);

export const findPost = (slug) => posts.find((p) => p.slug === slug);

export const getPostsByCategory = (category) =>
    posts.filter((p) => p.category === category).sort(byDateDesc);

export const getPostsBySeries = (seriesSlug) =>
    posts.filter((p) => p.series === seriesSlug).sort(bySeriesOrder);

export const getSeries = (seriesSlug) => series[seriesSlug];

export const getAllSeries = () => Object.values(series);

export const getSeriesByCategory = (category) =>
    Object.values(series).filter((s) => s.category === category);

// Get next/previous post in a series
export const getSeriesNavigation = (currentPost) => {
    if (!currentPost.series) return { prev: null, next: null };

    const seriesPosts = getPostsBySeries(currentPost.series);
    const currentIndex = seriesPosts.findIndex(p => p.slug === currentPost.slug);

    return {
        prev: currentIndex > 0 ? seriesPosts[currentIndex - 1] : null,
        next: currentIndex < seriesPosts.length - 1 ? seriesPosts[currentIndex + 1] : null,
        seriesInfo: getSeries(currentPost.series)
    };
};
